export default "__VITE_ASSET__niyPlM$r__"